import React from 'react'

function Grooming() {
  return (
    <div>Grooming</div>
  )
}

export default Grooming